window.bundleDataD = {
"Daisy-girl": {
displayName: "Daisy",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Daisy Personalized Coloring Experience",
variantId: "49279561433325",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Daisy_final_cover_106c64d7-5c55-48dd-bea8-731f9675094f.png?v=1772908493",
price: "$14.99",
preorder: true
},
{
title: "Daisy Unicorn Holographic Sticker",
variantId: "49933777273069",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Daisy_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Daisy Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Daleyza-girl": {
displayName: "Daleyza",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Daleyza Personalized Coloring Experience",
variantId: "49279561498861",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Daleyza_final_cover.png?v=1772851513",
price: "$14.99",
preorder: true
},
{
title: "Daleyza Unicorn Holographic Sticker",
variantId: "49933777240301",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Daleyza_holographic_sticker.png?v=1779425517",
price: "$4.99",
preorder: false
},
{
title: "Daleyza Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Damian-boy": {
displayName: "Damian",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Damian Personalized Coloring Experience",
variantId: "49274759020781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/damian_final_cover.png?v=1772318759",
price: "$14.99",
preorder: true
},
{
title: "Damian Dragon Holographic Sticker",
variantId: "49933780222189",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Damian_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Damian Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Danger-boy": {
displayName: "Danger",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Danger Personalized Coloring Experience",
variantId: "49351804453101",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Danger_final_cover.png?v=1772753296",
price: "$14.99",
preorder: true
},
{
title: "Danger Dragon Holographic Sticker",
variantId: "49933770621165",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Danger_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Danger Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Daniel-boy": {
displayName: "Daniel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Daniel Personalized Coloring Experience",
variantId: "49279561597165",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Daniel_final_cover.png?v=1772388164",
price: "$14.99",
preorder: true
},
{
title: "Daniel Dragon Holographic Sticker",
variantId: "49933777207533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Daniel_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Daniel Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Daniela-girl": {
displayName: "Daniela",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Daniela Personalized Coloring Experience",
variantId: "49279561695469",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Daniela_final_cover.png?v=1772908493",
price: "$14.99",
preorder: true
},
{
title: "Daniela Unicorn Holographic Sticker",
variantId: "49933777174765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Daniela_holographic_sticker.png?v=1779425517",
price: "$4.99",
preorder: false
},
{
title: "Daniela Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Danielle-girl": {
displayName: "Danielle",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Danielle Personalized Coloring Experience",
variantId: "49299050529005",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Danielle_final_cover.png?v=1773766535",
price: "$14.99",
preorder: true
},
{
title: "Danielle Unicorn Holographic Sticker",
variantId: "49933772980461",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Danielle_holographic_sticker.png?v=1779425515",
price: "$4.99",
preorder: false
},
{
title: "Danielle Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Daphne-girl": {
displayName: "Daphne",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Daphne Personalized Coloring Experience",
variantId: "49929664397549",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Daphne_final_cover.png?v=1775415417",
price: "$14.99",
preorder: true
},
{
title: "Daphne Unicorn Holographic Sticker",
variantId: "49933745783021",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Daphne_holographic_sticker.png?v=1779425512",
price: "$4.99",
preorder: false
},
{
title: "Daphne Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"David-boy": {
displayName: "David",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "David Personalized Coloring Experience",
variantId: "49279561793773",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/David_final_cover.png?v=1772388163",
price: "$14.99",
preorder: true
},
{
title: "David Dragon Holographic Sticker",
variantId: "49933777141997",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/David_holographic_sticker.png?v=1779378945",
price: "$4.99",
preorder: false
},
{
title: "David Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Dean-boy": {
displayName: "Dean",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Dean Personalized Coloring Experience",
variantId: "49279561957613",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Dean_final_cover.png?v=1772388161",
price: "$14.99",
preorder: true
},
{
title: "Dean Dragon Holographic Sticker",
variantId: "49933777109229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Dean_holographic_sticker.png?v=1779378943",
price: "$4.99",
preorder: false
},
{
title: "Dean Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Declan-boy": {
displayName: "Declan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Declan Personalized Coloring Experience",
variantId: "49279562023149",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Declan_final_cover.png?v=1772388163",
price: "$14.99",
preorder: true
},
{
title: "Declan Dragon Holographic Sticker",
variantId: "49933777076461",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Declan_holographic_sticker.png?v=1779378943",
price: "$4.99",
preorder: false
},
{
title: "Declan Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Delilah-girl": {
displayName: "Delilah",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Delilah Personalized Coloring Experience",
variantId: "49479294517485",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Delilah_final_cover.png?v=1772930026",
price: "$14.99",
preorder: true
},
{
title: "Delilah Unicorn Holographic Sticker",
variantId: "49933758300397",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Delilah_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Delilah Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Demy-girl": {
displayName: "Demy",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Demy Personalized Coloring Experience",
variantId: "49274284540141",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Demy_final_cover.png?v=1773719957",
price: "$14.99",
preorder: true
},
{
title: "Demy Unicorn Holographic Sticker",
variantId: "49933780975853",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Demy_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Demy Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Derek-boy": {
displayName: "Derek",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Derek Personalized Coloring Experience",
variantId: "49279567855853",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Derek_final_cover.png?v=1772388164",
price: "$14.99",
preorder: true
},
{
title: "Derek Dragon Holographic Sticker",
variantId: "49933777043693",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Derek_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Derek Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Diana-girl": {
displayName: "Diana",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Diana Personalized Coloring Experience",
variantId: "49479211221229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Diana_final_cover.png?v=1772930029",
price: "$14.99",
preorder: true
},
{
title: "Diana Unicorn Holographic Sticker",
variantId: "49933758759149",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Diana_holographic_sticker.png?v=1779425517",
price: "$4.99",
preorder: false
},
{
title: "Diana Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Diego-boy": {
displayName: "Diego",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Diego Personalized Coloring Experience",
variantId: "49279567986925",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Diego_final_cover.png?v=1772388164",
price: "$14.99",
preorder: true
},
{
title: "Diego Dragon Holographic Sticker",
variantId: "49933777010925",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Diego_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Diego Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Dillon-boy": {
displayName: "Dillon",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Dillon Personalized Coloring Experience",
variantId: "49431504290029",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Dillon_final_cover.png?v=1772388164",
price: "$14.99",
preorder: true
},
{
title: "Dillon Dragon Holographic Sticker",
variantId: "49933759807725",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Dillon_holographic_sticker.png?v=1779378942",
price: "$4.99",
preorder: false
},
{
title: "Dillon Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Diya-girl": {
displayName: "Diya",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Diya Personalized Coloring Experience",
variantId: "49479225671917",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Diya_final_cover.png?v=1772930029",
price: "$14.99",
preorder: true
},
{
title: "Diya Unicorn Holographic Sticker",
variantId: "49933758562541",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Diya_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Diya Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Dominic-boy": {
displayName: "Dominic",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Dominic Personalized Coloring Experience",
variantId: "49279568052461",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Dominic_final_cover.png?v=1772388165",
price: "$14.99",
preorder: true
},
{
title: "Dominic Dragon Holographic Sticker",
variantId: "49933776978157",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Dominic_holographic_sticker.png?v=1779378943",
price: "$4.99",
preorder: false
},
{
title: "Dominic Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Donna-girl": {
displayName: "Donna",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Donna Personalized Coloring Experience",
variantId: "49731902210285",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Donna_final_cover.png?v=1774739906",
price: "$14.99",
preorder: true
},
{
title: "Donna Unicorn Holographic Sticker",
variantId: "49933753352429",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Donna_holographic_sticker.png?v=1779378943",
price: "$4.99",
preorder: false
},
{
title: "Donna Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Dylan-boy": {
displayName: "Dylan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Dylan Personalized Coloring Experience",
variantId: "49279568216301",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Dylan_final_cover.png?v=1771691709",
price: "$14.99",
preorder: true
},
{
title: "Dylan Dragon Holographic Sticker",
variantId: "49933776552173",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Dylan_holographic_sticker.png?v=1779378945",
price: "$4.99",
preorder: false
},
{
title: "Dylan Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Dawson-boy": {
displayName: "Dawson",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Dawson Personalized Coloring Experience",
variantId: "50127696068845",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Dawsonfinalcover.png?v=1781987998",
price: "$14.99",
preorder: true
},
{
title: "Dawson Dragon Holographic Sticker",
variantId: "50127672934637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Dawsonwebsitesticker.png?v=1781987100",
price: "$4.99",
preorder: false
},
{
title: "Dawson Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Dallas-boy": {
displayName: "Dallas",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Dallas Personalized Coloring Experience",
variantId: "50449684463853",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Dallas_final_cover.png?v=1786244941",
price: "$14.99",
preorder: true
},
{
title: "Dallas Dragon Holographic Sticker",
variantId: "50449578688749",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Dallas_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Dallas Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} 



};